import React, { useEffect, useRef, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../../components/Layout";
import { useNavigate } from "react-router-dom";
import ToastFile from "../../../utils/ToastFile";
import { getAllTaskLogbyEmployeePagination } from "../../../api/TaskApi";
import moment from "moment";
import { TaskStatusEnum } from "../../../config/staticArray";
import { getAllRoutebyContractor } from "../../../api/RouteApi";
import Loader from "../../../components/Loader";
import { MdModeEdit } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle, IoIosTime } from "react-icons/io";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { formatHours } from "../../../utils/utility";
import { getEmployeeDetails } from "../../../api/EmployeeApi";

const TaskHistory = () => {
  const [taskLogs, setTaskLogs] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [routeOptions, setRouteOptions] = useState([]);
  const [isLoading, setIsloading] = useState(true)
  const [page, setPage] = useState(1); // 1-based index
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [isFixedPay, setIsFixedPay] = useState(false);
  const [isUnpaidBreak, setIsUnpaidBreak] = useState(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    // getTaskLog();
    getRoute();
    if (user?.id) {
      getEmployeeDetails(user.id).then((res) => {
        if (res.status === 200) {
          const employee = res?.data?.data;
          if (employee?.settings) {
            try {
              const settings =
                typeof employee.settings === "string"
                  ? JSON.parse(employee.settings)
                  : employee.settings;
              setIsFixedPay(
                Boolean(
                  settings?.FixedPay ||
                    settings?.fixedPay ||
                    settings?.["Fixed Pay"],
                ),
              );
              setIsUnpaidBreak(Boolean(settings?.UnpaidBreak));
            } catch (e) {
              console.error("Error parsing settings:", e);
            }
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map(
      (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
    );
  }, []);

  const getTaskLog = () => {
    setIsloading(true)
    getAllTaskLogbyEmployeePagination(user.id, page, pageSize)
      .then((res) => {
        if (res.status === 200) {
          setTaskLogs(res?.data?.data?.taskLogs);
          setTotalCount(res.data?.data?.no_of_tasks);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  useEffect(() => {
    getTaskLog();
  }, [page, pageSize]);

  const totalPages = Math.ceil(totalCount / pageSize);

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRouteOptions(res?.data?.data?.routes);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      });
  };

  const openEditModal = (_id) => {
      let taskLog = taskLogs.find((el) => el._id === _id);
      taskLog.date = moment(taskLog.date).format("YYYY-MM-DD");
      taskLog.startTime = moment(taskLog.startTime).format("HH:mm");
      taskLog.endTime = moment(taskLog.endTime).format("HH:mm");
      navigate("/mytask/edit", {
        replace: true,
        state: { taskLog, mode: "Edit", from:"taskhistory" },
      });
  };

  return (
    <Layout>
      {/* Header Section - Mobile Responsive */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
         <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
      Task History
          </span>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th className="text-nowrap">Category</th>
              <th className="text-nowrap d-none d-lg-table-cell">Route</th>
              <th className="text-nowrap">Date</th>
              <th className="d-none d-md-table-cell">Start Time</th>
              <th className=" d-none d-md-table-cell">End Time</th>
              <th className=" d-none d-md-table-cell">Actual working hours</th>
              <th className=" d-none d-md-table-cell">Unpaid Breaks</th>
              <th className="d-none d-lg-table-cell">
                {isFixedPay ? "Number of Run" : "Claim Hours / No of Parcels"}
              </th>
              <th className="d-none d-lg-table-cell">
                {isFixedPay ? "Fix Pay Rate" : "Pay Rate / Per Parcel Cost"}
              </th>
              <th className="d-none d-xl-table-cell">Fuel Cost</th>
              <th className=" d-none d-xl-table-cell">Total Cost</th>
              <th className="text-nowrap">Status</th>
              <th className="text-nowrap">Approved</th>
              <th>Actions</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan="12">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {taskLogs.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center">
                    No task found
                  </td>
                </tr>
              ) : (
                taskLogs.map((c, idx) => (
                  <tr key={idx}>
                    <td className="text-nowrap">
                      <div className="fw-bold">{c.category}</div>
                      <small className="text-muted d-md-none">
                        {moment(c.startTime).format("hh:mm A")} -{" "}
                        {moment(c.endTime).format("hh:mm A")}
                      </small>
                    </td>
                    <td className="text-nowrap d-none d-lg-table-cell">
                      {c.routeInfo.map((item, index) => {
                        const matched = routeOptions.find(
                          (el) => el._id === item
                        );
                        return (
                          <span key={index}>
                            {matched?.routeName}
                            {index < c.routeInfo.length - 1 ? ", " : ""}
                          </span>
                        );
                      })}
                    </td>
                    <td style={{ textAlign: "center" }} className="text-nowrap">
                      {moment(c.date).format("DD-MM-YYYY")}
                    </td>
                    <td
                      style={{ textAlign: "center" }}
                      className="text-nowrap d-none d-md-table-cell"
                    >
                      {moment(c.startTime).format("hh:mm A")}
                    </td>
                    <td
                      style={{ textAlign: "center" }}
                      className="text-nowrap d-none d-md-table-cell"
                    >
                      {moment(c.endTime).format("hh:mm A")}
                    </td>
                     <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {(c.actualHours == 0 || parseInt(c.actualHours?.split(':')[0]) > 15) ? 'N/A': formatHours(c.actualHours)}
                    </td>
                    <td
                      style={{ textAlign: "center" }}
                      className="text-nowrap d-none d-md-table-cell"
                    >
                      {(() => {
                        const [hours = "0", minutes = "0"] = String(
                          c.actualHours || "0:00",
                        )
                          .split(":")
                          .map(Number);
                        return isUnpaidBreak && hours * 60 + minutes > 5 * 60
                          ? "30 mins"
                          : "0 min";
                      })()}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {c.claimHours}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-lg-table-cell"
                    >
                      {c.payrate}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-xl-table-cell"
                    >
                      {c.fuelCost}
                    </td>
                    <td
                      style={{ textAlign: "end" }}
                      className="text-nowrap d-none d-xl-table-cell"
                    >
                      {c.totalCost}
                    </td>
                    <td style={{ textAlign: "center" }} className="text-nowrap">
                      {c.status === TaskStatusEnum.IN_PROGRESS && (
                        <span className="badge bg-warning">{c.status}</span>
                      )}
                      {c.status === TaskStatusEnum.COMPLETED && (
                        <span className="badge bg-success">{c.status}</span>
                      )}
                      {c.status === TaskStatusEnum.CANCELLED && (
                        <span className="badge bg-danger">{c.status}</span>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }} className="text-nowrap">
                      {c.isApproved === "Yes" ? (
                        <span><FaCheckCircle size={16} color="green"/></span>
                      ) : c.isApproved === "No" ? (
                        <span><IoIosCloseCircle size={20} color="red"/></span>
                      ) : <span><IoIosTime size={20} color="grey"/></span> }
                    </td>
                    <td style={{ textAlign: "center" }}>
                     <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>This feature is disabled by the contractor. Please contact the contractor for any changes.</Tooltip>}
                    >
                      <span className="d-inline-block">
                        <button
                          type="button"
                          className="me-2 btn btn-link p-0"
                          disabled
                          style={{ pointerEvents: "none" }}
                          //onClick={() => openEditModal(c._id)}
                        >
                          <MdModeEdit size={16} />
                        </button>
                      </span>
                    </OverlayTrigger>
                      {/* <span
                        className="me-2"
                        disabled={true}
                        style={{ cursor: "pointer" }}
                        onClick={() => openEditModal(c._id)}
                      >
                        <MdModeEdit size={16} />
                      </span> */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-center align-items-center mb-3 ">
        
      <div className="d-flex justify-content-center align-items-center mt-2 d-none d-md-block">
        <div className="d-flex justify-content-center mb-1">
          Showing {(page - 1) * pageSize + 1} to{" "}
          {Math.min(page * pageSize, totalCount)} of {totalCount}
        </div>

        <div className="d-flex align-items-center gap-2">
          <Button
            variant="secondary"
            size="sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </Button>

          <span>
            Page {page} of {totalPages}
          </span>

          <Button
            variant="secondary"
            size="sm"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </Button>
        </div>
      </div>
      </div>

      {/* Mobile Card View for Small Screens */}
      {isLoading ? <div className="d-md-none"> <Loader/></div> : 
      <div className="d-md-none">
        {taskLogs.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No task found</p>
          </div>
        ) : (
          <div className="row g-3">
            {taskLogs.map((c, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{c.category}</h6>
                        <small className="text-muted d-block">
                          {moment(c.date).format("DD-MM-YYYY")}
                        </small>
                      </div>
                      <div className="text-end">
                         <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>This feature is disabled by the contractor. Please contact the contractor for any changes.</Tooltip>}
                    >
                      <span className="d-inline-block">
                        <button
                          type="button"
                          className="me-2 btn btn-link p-0"
                          disabled
                          style={{ pointerEvents: "none" }}
                          //onClick={() => openEditModal(c._id)}
                        >
                          <MdModeEdit size={16} />
                        </button>
                      </span>
                    </OverlayTrigger>
                          {/* <div className="mb-2">
                            <span
                        className="me-2"
                        disabled={true}
                        style={{ cursor: "pointer" }}
                        onClick={() => openEditModal(c._id)}
                      >
                        <MdModeEdit size={16} />
                      </span>
                            </div> */}
                        <div className="mb-2">
                          {c.status === TaskStatusEnum.IN_PROGRESS && (
                            <span className="badge bg-warning">{c.status}</span>
                          )}
                          {c.status === TaskStatusEnum.COMPLETED && (
                            <span className="badge bg-success">{c.status}</span>
                          )}
                          {c.status === TaskStatusEnum.CANCELLED && (
                            <span className="badge bg-danger">{c.status}</span>
                          )}
                        </div>
                          <div>
                            {c.isApproved === "Yes" ? (
                              <span className="badge bg-success">Approved</span>
                            ) : c.isApproved === "No" ? (
                              <span className="badge bg-danger">Rejected</span>
                            ) : (
                              <span className="badge bg-secondary">
                                Pending
                              </span>
                            )}
                          </div>
                          
                        </div>
                      </div>

                      <div className="row g-2 mb-3">
                         {c.routeInfo && c.routeInfo.length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted d-block">Route</small>
                          <span className="small">
                            {c.routeInfo.map((item, index) => {
                              const matched = routeOptions.find(
                                (el) => el._id === item
                              );
                              return (
                                <span key={index}>
                                  {matched?.routeName}
                                  {index < c.routeInfo.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </span>
                        </div>
                      )}
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Start Time
                          </small>
                          <span>{moment(c.startTime).format("hh:mm A")}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">End Time</small>
                          <span>{moment(c.endTime).format("hh:mm A")}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Actual working hours
                          </small>
                          <span>{(c.actualHours == 0 || parseInt(c.actualHours?.split(':')[0]) > 15) ? 'N/A': formatHours(c.actualHours)}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Unpaid Breaks
                          </small>
                          <span>
                            {(() => {
                              const [hours = 0, minutes = 0] = String(
                                c.actualHours || "0:00",
                              )
                                .split(":")
                                .map(Number);
                              return isUnpaidBreak && hours * 60 + minutes > 5 * 60
                                ? "30 mins"
                                : "0 min";
                            })()}
                          </span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Claim Hours / No of Parcels
                          </small>
                          <span>{c.claimHours}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Pay Rate / Per Parcel Cost
                          </small>
                          <span>${c.payrate}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Fuel Cost
                          </small>
                          <span>${c.fuelCost}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Total Cost
                          </small>
                          <span>${c.totalCost}</span>
                        </div>
                      </div>

                     
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      }
    </Layout>
  );
};

export default TaskHistory;
